import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UNIT_LIST, COMPANY_DETAILS, SAVE_EXPENSE, GET_EXPENSE_NUMBER, EXPENSE_ORDER } from '../../../data/url';
import Alert from '../../../feature/Alert';
import Helper from '../../../helper/Helper';
import httpClient from '../../../http/HttpRequest';
import SelectVendor from '../layout/SelectVendor';
import { PAYMENT_MODE, VENDOR_ITEMS } from '../../../data/constant';
import Select from 'react-select';

export default function NewExpense() {

     const [state_id, setState] = useState('');
     const [vendor_id, setVendorId] = useState('');
     const [vendor, setVendor] = useState({});
     const [errors, setErrors] = useState({});
     const [venorItems, setVendorItems] = useState({});
     const { t } = useTranslation();
     const navigate = useNavigate();
     const [unitList, setUnitList] = useState({});
     const [expenseDetails, setExpenseDetails] = useState({prefix : '', number: '', date: Helper.getToday(), payment_mode: '', ref_number: '', item_name: null, unit: null, quantity: 1, price: 0, tax: 0, total: '', taxableAmount: '', taxAmount: '', terms_conditions: '', private_notes: '', cgst: 0, igst: 0, sgst: 0, rounded_off: 0 });
     const thStyle = { lineHeight: "1", verticalAlign: "center" };
     const [sameState, setSameState] = useState(0);
     const [companyData, setcompanyData] = useState({});
     const { id } = useParams();

     useEffect(() => {
          getUnit();
          setVendorItem();
          getCompanyDetails();
          if (id === undefined) {
               getNumber();
          }
         
     }, [])

     useEffect(() => {
          if (id !== undefined && Object.keys(unitList).length > 0) {
               getExpenseData();
          }
     }, [id,unitList])

     const getExpenseData = async (e) => {
          const res = await httpClient.post(EXPENSE_ORDER, { id: id });
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let data = result.data;
                    setVendorId(data['vendor_id']);                   
                    for (let key in expenseDetails) {
                         if (expenseDetails.hasOwnProperty(key) && data.hasOwnProperty(key)) {
                              if (key === 'item_name') {
                                   setExpenseDetails(prevState => ({ ...prevState, [key]: { value: data[key], label: data[key] } }));
                              } else if(key === 'unit') {  
                                   let u = findUnit(data[key])
                                   setExpenseDetails(prevState => ({ ...prevState, [key]: u }));                                                               
                              } else  {
                                   setExpenseDetails(prevState => ({ ...prevState, [key]: data[key] }));
                              }
                         }
                    }                   
               }
          }
     }

     const getUnit = async (e) => {
          const res = await httpClient.post(UNIT_LIST, {});
          if (res.requestStatus == "OK") {
               const result = res.result;
               if (result.status == 1) {
                    let options = [];
                    result.data.forEach((row, index) => {
                         options.push({ label: row.name, value: row.id });
                    });
                    setUnitList(options);
               }
          }
     }

     const findUnit = (unit) => { 
          const foundUnit = unitList.find(element => element && element.value == unit); 
          if (foundUnit) { 
               return foundUnit;
          }          
     }

     const getNumber = async (e) => {
          const res = await httpClient.post(GET_EXPENSE_NUMBER, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setExpenseDetails(prevExpanseDetails => ({
                         ...prevExpanseDetails,
                         number: result.number ||'',
                         prefix : result.prefix || ''
                    }));
               }
          }
     }

     const setVendorItem = () => {
          let options = [];
          Object.entries(VENDOR_ITEMS).map(([key, value]) => (
               options.push({ label: value, value: value })
          ))
          setVendorItems(options);

     }

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setcompanyData(result.data);
               } else {
                    Alert.error(res.message);
               }
          }
     };

     useEffect(() => {
          if (vendor.state === companyData.state) {
               setSameState(1);
          } else {
               setSameState(0);
          }
     }, [vendor]);

     const validateField = () => {
          let formErrors = {};
          let valid = true;
          if (expenseDetails.number === '') {
               formErrors.number = "Number is required"
               valid = false;
          }
          if (expenseDetails.date === '') {
               formErrors.date = "Date is required";
               valid = false;
          }
          if (expenseDetails.payment_mode === '') {
               formErrors.payment_mode = "Payment mode is required";
               valid = false;
          }
          if (expenseDetails.item_name === null) {
               formErrors.item_name = "Item is required";
               valid = false;
          }
          if (expenseDetails.quantity === '') {
               formErrors.quantity = "Quantity is required";
               valid = false;
          }
          if (expenseDetails.price === '') {
               formErrors.price = "Price is required";
               valid = false;
          }
          if (expenseDetails.tax === '') {
               formErrors.tax = "Price is required";
               valid = false;
          }
          if (vendor_id === '') {
               Alert.error('Kindly select vendor');
               valid = false;
          }
          setErrors(formErrors);
          return valid;
     }

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const order = { ...expenseDetails };
          order[fieldName] = value;
          setExpenseDetails(order);
     };

     const calculation = () => {
          let price = Helper.convertToDecimal(expenseDetails.price);
          if (price) {
               let qty = Helper.convertToDecimal(expenseDetails.quantity);
               if (qty) {
                    let tax = Helper.convertToDecimal(expenseDetails.tax);
                    if (tax !== undefined) {
                         let total = price * qty;
                         let taxAmount = (total * (tax / 100));
                         let final = taxAmount + total;
                         let cgst = 0; let sgst = 0; let igst = 0;
                         if (sameState == 1) {
                              cgst = tax / 2;
                              sgst = tax / 2;
                         } else {
                              igst = tax;
                         }
                         const order = { ...expenseDetails };
                         order.taxableAmount = total;
                         order.taxAmount = taxAmount;
                         order.cgst = cgst;
                         order.igst = igst;
                         order.sgst = sgst;
                         let roundedAmount = Math.round(final);
                         order.total = roundedAmount;
                         order.rounded_off = roundedAmount - final;
                         setExpenseDetails(order);
                    }
               }
          }
     }

     const remitVendor = (data) => {
          setVendorId(data.vendor_id);
          setState(data.state_id);
          setVendor(data.vendor);
     }

     const onUnitChange = (selectedOption) => {
          const updatedRows = { ...expenseDetails };
          updatedRows.unit = selectedOption;
          setExpenseDetails(updatedRows);
     };

     const onItemChange = (selectedOption) => {
          const updatedRows = { ...expenseDetails };
          updatedRows.item_name = selectedOption;
          setExpenseDetails(updatedRows);
     };

     const handelSubmit = () => {
          if (validateField()) {
               let post = { ...expenseDetails };
               post['vendor_id'] = vendor_id;
               post['state_id'] = state_id;
               post['item_name'] = expenseDetails.item_name.value;
               post['unit'] = expenseDetails.unit !== null ? expenseDetails.unit.value : null;
               if (id !== undefined) {
                    post['id'] = id;
               }
               saveOrder(post);
          }
     }

     const saveOrder = async (post) => {
          const res = await httpClient.post(SAVE_EXPENSE, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status == 1) {
                    Alert.success(result.message);
                    navigate('/root/expense');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     return (
          <AdminLayout >
               <div className="content-wrapper">
                    <ContentHeader title={id === undefined ? 'new_expense' : "edit_expense"} subTitle="expense" subTitleLink="root/expense" />
                    <div className="col-lg-12 grid-margin stretch-card">
                         <div className="card">
                              <div className="card-body">
                                   <div>
                                        <SelectVendor remitVendor={remitVendor} vendorId={vendor_id} />
                                   </div>
                                   <div className='row mt-2'>
                                        <div className='col-md-3'>
                                             <label htmlFor='number'>{t('number')}</label>
                                             <div className='input-group'>
                                                  <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                                                       <input id='prefix' value={expenseDetails.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                                  </div>
                                                  <input id='number' value={expenseDetails.number} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                                             </div>
                                             {errors && errors.number && <span className='text-danger'>{errors.number}</span>}
                                        </div>
                                        <div className='col-md-3'>
                                             <label htmlFor='date'>{t('date')}</label>
                                             <input id='data' value={expenseDetails.date} type='date' name='date' className='form-control form-control-sm' onChange={(e) => handleInputChange('date', e)} />
                                             {errors && errors.date && <span className='text-danger'>{errors.date}</span>}
                                        </div>
                                        <div className='col-md-3'>
                                             <label htmlFor='mode'>{t('mode')}</label>
                                             <select id='mode' name='payment_mode' className='form-control form-control-sm' onChange={(e) => handleInputChange('payment_mode', e)}>
                                                  <option value=''>Select</option>
                                                  {Object.entries(PAYMENT_MODE).map(([key, value]) => (
                                                       <option key={key} value={key} selected={key === expenseDetails.payment_mode ? true : false}>
                                                            {value}
                                                       </option>
                                                  ))}
                                             </select>
                                             {errors && errors.payment_mode && <span className='text-danger'>{errors.payment_mode}</span>}
                                        </div>
                                        <div className='col-md-3'>
                                             <label htmlFor='ref_number'>{t('ref_number')}</label>
                                             <input id='ref_number' value={expenseDetails.ref_number} type='text' name='ref_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('ref_number', e)} />
                                        </div>
                                   </div>
                                   <hr />
                                   <div className='row'>
                                        <div className='col-md-4'>
                                             <label htmlFor='item_name'>{t('item_name')}</label>
                                             <Select
                                                  id='item_name'
                                                  value={expenseDetails.item_name}
                                                  options={venorItems}
                                                  isSearchable={true}
                                                  placeholder="Select"
                                                  onChange={(selectedOption) => onItemChange(selectedOption)}
                                             />
                                             {errors && errors.item_name && <span className='text-danger'>{errors.item_name}</span>}
                                        </div>
                                        <div className="col-md-2">
                                             <label htmlFor='unit'>{t('unit')}</label>
                                             <Select
                                                  id='unit'
                                                  value={expenseDetails.unit}
                                                  options={unitList}
                                                  isSearchable={true}
                                                  placeholder="Select"
                                                  onChange={(selectedOption) => onUnitChange(selectedOption)}
                                             />
                                        </div>
                                        <div className='col-md-2'>
                                             <label htmlFor='quantity'>{t('quantity')}</label>
                                             <input id='quantity' value={expenseDetails.quantity} type='number' name='quantity' className='form-control form-control-sm' onChange={(e) => handleInputChange('quantity', e)} onBlur={calculation} />
                                             {errors && errors.quantity && <span className='text-danger'>{errors.quantity}</span>}
                                        </div>
                                        <div className='col-md-2'>
                                             <label htmlFor='price'>{t('price')}</label>
                                             <input id='price' value={expenseDetails.price} type='number' name='price' className='form-control form-control-sm' onChange={(e) => handleInputChange('price', e)} onBlur={calculation} />
                                             {errors && errors.price && <span className='text-danger'>{errors.price}</span>}
                                        </div>
                                        <div className='col-md-2'>
                                             <label htmlFor='tax'>{t('tax')}</label>
                                             <input id='tax' value={expenseDetails.tax} type='number' name='tax' className='form-control form-control-sm' onChange={(e) => handleInputChange('tax', e)} onBlur={calculation} />
                                             {errors && errors.tax && <span className='text-danger'>{errors.tax}</span>}
                                        </div>
                                   </div>
                                   {expenseDetails.item_name !== null &&
                                        <div className='mt-4'>
                                             <div className='table-responsive'>
                                                  <table className='table table-striped table-bordered table-hovered'>
                                                       <thead>
                                                            <tr className='text-center' >
                                                                 <th >#</th>
                                                                 <th>{t('item_name')}</th>
                                                                 <th>{t('unit')}</th>
                                                                 <th>{t('qty')}</th>
                                                                 <th>{t('price')}</th>
                                                                 {sameState == 1 ? <><th>{t('cgst')}</th><th>{t('sgst')}</th></> : <th>{t('igst')}</th>}
                                                            </tr>
                                                       </thead>
                                                       <tbody>
                                                            <tr>
                                                                 <td>1</td>
                                                                 <td style={{ width: "200px" }}>{expenseDetails.item_name.value} </td>
                                                                 <td>{expenseDetails.unit !== null ? expenseDetails.unit.label : ''}</td>
                                                                 <td>{expenseDetails.quantity}</td>
                                                                 <td className='text-right'>{Helper.formatNumber(expenseDetails.price)}</td>
                                                                 {sameState == 1 ? <>
                                                                      <td className='text-right'>{Helper.formatNumber(expenseDetails.cgst)} %</td>
                                                                      <td className='text-right'>{Helper.formatNumber(expenseDetails.sgst)} %</td>
                                                                 </> :
                                                                      <td className='text-right'>{Helper.formatNumber(expenseDetails.igst)} %</td>
                                                                 }
                                                            </tr>
                                                       </tbody>
                                                  </table>
                                             </div>
                                             <div className='row mt-3'>
                                                  <div className='col-md-8'>
                                                  </div>
                                                  <div className='col-md-4'>
                                                       <table className='table table-sm table-borderless'>
                                                            <tbody>
                                                                 <tr>
                                                                      <td style={thStyle}><strong>{t('subtotol')}</strong></td>
                                                                      <td style={thStyle} className='text-right'><strong>{Helper.formatNumber(expenseDetails.taxableAmount)}</strong></td>
                                                                 </tr>
                                                                 {sameState == 1 &&
                                                                      <>
                                                                           <tr>
                                                                                <td style={thStyle}><strong>{t('cgst')}</strong></td>
                                                                                <td style={thStyle} className='text-right'><strong>{Helper.formatNumber(expenseDetails.taxAmount / 2)}</strong></td>
                                                                           </tr>
                                                                           <tr>
                                                                                <td style={thStyle}><strong>{t('sgst')}</strong></td>
                                                                                <td style={thStyle} className='text-right'><strong>{Helper.formatNumber(expenseDetails.taxAmount / 2)}</strong></td>
                                                                           </tr>
                                                                      </>
                                                                 }
                                                                 {sameState == 0 &&
                                                                      <tr>
                                                                           <td style={thStyle}><strong>{t('igst')}</strong></td>
                                                                           <td style={thStyle} className='text-right'><strong>{expenseDetails.taxAmount}</strong></td>
                                                                      </tr>
                                                                 }
                                                                 {expenseDetails.rounded_off !== 0 &&
                                                                      <tr>
                                                                           <td style={thStyle}><strong>{t('rounded_off')}</strong></td>
                                                                           <td style={thStyle} className='text-right'><strong>{Helper.formatNumber(expenseDetails.rounded_off)}</strong></td>
                                                                      </tr>
                                                                 }
                                                                 <tr>
                                                                      <td style={thStyle} className='text-success'><strong>{t('Total')}</strong></td>
                                                                      <td style={thStyle} className='text-right text-success'><strong>{Helper.formatNumber(expenseDetails.total)}</strong></td>
                                                                 </tr>
                                                            </tbody>
                                                       </table>
                                                  </div>
                                             </div>
                                        </div>
                                   }
                                   <hr />
                                   <div className='row'>
                                        <div className='col-md-6'>
                                             <label htmlFor='terms_conditions'>{t('terms_conditions')}</label>
                                             <textarea className='form-control form-control-sm' id='terms_conditions' value={expenseDetails.terms_conditions} onChange={(e) => handleInputChange('terms_conditions', e)}></textarea>
                                        </div>
                                        <div className='col-md-6'>
                                             <label htmlFor='private_notes'>{t('private_notes')}</label>
                                             <textarea className='form-control form-control-sm' id='private_notes' value={expenseDetails.private_notes} onChange={(e) => handleInputChange('private_notes', e)}></textarea>
                                        </div>
                                   </div>
                                   <div className='text-center mt-2'>
                                        <button className='btn btn-primary auto_click' onClick={handelSubmit}>{t('save')}</button>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </AdminLayout >
     )
}
